import React, { FunctionComponent, useRef } from 'react'
import { useTranslation } from 'react-i18next'

import { useMediaQueryContext } from 'contexts/MediaQueryContext'

import LazyImage from '../../../components/display/LazyImage'

import Brief from '../../../components/landing/Brief'
// import FAQ from '../shared/FAQ'
import Header, {
  useLearnMoreClickHandler,
} from '../../../components/landing/Header'
import IllustratedSteps from '../../../components/landing/IllustratedSteps'
import InfoParagraph from '../../../components/landing/InfoParagraph'
import MasonryImages from '../../../components/landing/MasonryImages'
import SectionIntro from '../../../components/landing/SectionIntro'
import StoriesCarousel from '../../../components/landing/StoriesCarousel'
import Testimonials from '../../../components/landing/Testimonials'
import {
  SpacedColumn,
  Container,
  PageCTALink,
  ResponsiveTwoColumnLayout,
} from '../../../components/landing/display'

import {
  benefitsImages,
  benefitsText,
  briefText,
  // faqItems,
  headerImage,
  headerText,
  howItWorksSteps,
  storiesForCarousel,
  testimonials,
} from './content'

const StoriesLandingHost: FunctionComponent<{}> = () => {
  const { md: isLargerThanMd } = useMediaQueryContext()

  const briefEl = useRef<HTMLDivElement>()
  const headerImgEl = useRef<HTMLImageElement>()

  const handleLearnMoreClick = useLearnMoreClickHandler({
    smallScreenTarget: headerImgEl,
    largeScreenTarget: briefEl,
  })

  const [t] = useTranslation('spelling')

  return (
    <>
      <Header
        onCtaClick={handleLearnMoreClick}
        h1Text="Riparide Stories"
        h2Text={headerText.heading}
        h3Text={headerText.subheading}
      >
        <LazyImage
          ref={headerImgEl}
          data-src={headerImage.large.url}
          data-srcset={`
            ${headerImage.medium.url} ${headerImage.medium.width}w,
            ${headerImage.large.url} ${headerImage.large.width}w,
            ${headerImage.hero.url} ${headerImage.hero.width}w,
          `}
          preload
        />
      </Header>

      <Container ref={briefEl}>
        <Brief text={briefText} />
      </Container>

      <StoriesCarousel stories={storiesForCarousel} />

      <Container style={{ marginBottom: 0 }}>
        <SectionIntro
          primaryHeading="Why use Riparide Stories?"
          secondaryHeading="Host Benefits"
          paragraphText={`Properties with a Riparide Story are visually beautiful, drive more bookings and help deliver ${t(
            'traveler'
          )} fulfillment.`}
        />
        <ResponsiveTwoColumnLayout>
          <SpacedColumn>
            {benefitsText.map(({ heading, text }) => (
              <InfoParagraph heading={heading} text={text} />
            ))}
          </SpacedColumn>
          {isLargerThanMd && (
            <div>
              <MasonryImages
                images={benefitsImages}
                imagesPerColumn={{
                  1: 3,
                  2: 4,
                  3: 4,
                }}
              />
            </div>
          )}
        </ResponsiveTwoColumnLayout>

        <SectionIntro
          primaryHeading="Hear it from our hosts"
          paragraphText="Here’s what some of our hosts think about Riparide Stories."
          style={{ marginBottom: isLargerThanMd ? 60 : 40 }}
        />
      </Container>

      <Testimonials testimonials={testimonials} />

      <Container style={{ marginTop: 120 }}>
        <SectionIntro
          primaryHeading="How It works"
          secondaryHeading="Riparide Stories"
          paragraphText="Create your listing, welcome your Storyteller and enjoy beautiful photos and better bookings."
        />
        <IllustratedSteps steps={howItWorksSteps} />
        <PageCTALink
          href="/list-with-us"
          target="_blank"
          rel="noopener noreferrer"
        >
          Become a Host
        </PageCTALink>
        {/* <FAQ items={faqItems} /> */}
      </Container>
    </>
  )
}

export default StoriesLandingHost
